// Register Alpine Magic for $tooltip
document.addEventListener('alpine:init', () => {
    // Magic: $tooltip
    Alpine.magic('tooltip', el => message => {
        import('tippy.js').then(tippy => {
            import('tippy.js/dist/tippy.css'); // optional for styling

            let instance = tippy.default(el, { content: message, trigger: 'manual' });

            instance.show();

            setTimeout(() => {
                instance.hide();

                setTimeout(() => instance.destroy(), 150);
            }, 5000)
        });
    });

    // Directive: x-tooltip
    //
    // - `x-tooltip="<static text or html>"` uses the attribute value as-is.
    // - `x-tooltip.dynamic="<js expression>"` evaluates the expression in the
    //   element's Alpine scope and updates the tooltip whenever it changes.
    //
    // Note: `:x-tooltip="..."` (x-bind) does NOT work. Alpine applies bound
    // attributes with its own mutation observer disconnected, so a directive
    // added that way is never initialised.
    Alpine.directive('tooltip', (el, { expression, modifiers }, { evaluateLater, effect, cleanup }) => {
        const getContent = modifiers.includes('dynamic')
            ? evaluateLater(expression)
            : callback => callback(expression);

        let instance = null;
        let destroyed = false;

        import('tippy.js').then(tippy => {
            if (destroyed) {
                return;
            }

            import('tippy.js/dist/tippy.css'); // optional for styling

            instance = tippy.default(el, {
                content: '',
                trigger: 'mouseenter click',
                allowHTML: true,
                delay: [0, 100],
                maxWidth: 340,
            });

            effect(() => getContent(content => instance.setContent(content ?? '')));
        });

        cleanup(() => {
            destroyed = true;
            instance?.destroy();
        });
    })
})
